import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { Component, Input, EventEmitter, ElementRef, Inject, HostBinding, Output, HostListener, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FadvBaseComponent, Forward, mixinFocusEvent, mixinBlurEvent, Track, focusEventOutput, blurEventOutput, FadvCommonModule } from '@fa-switch-sharedservices/ng-elements/common';
import '@fa-switch-sharedservices/web-elements/components/message-box/message-box';
import { FadvIconModule } from '@fa-switch-sharedservices/ng-elements/fadv-icon';

class FadvMessageComponent extends FadvBaseComponent {
    constructor() {
        super(...arguments);
        this.heading = '';
        this.description = '';
    }
}
FadvMessageComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvMessageComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
FadvMessageComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvMessageComponent, selector: "fadv-message", inputs: { heading: "heading", description: "description" }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
__decorate([
    Forward()
], FadvMessageComponent.prototype, "heading", void 0);
__decorate([
    Forward()
], FadvMessageComponent.prototype, "description", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvMessageComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-message',
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { heading: [{
                type: Input
            }], description: [{
                type: Input
            }] } });
class FadvMessageInputComponent extends mixinFocusEvent(mixinBlurEvent(FadvBaseComponent)) {
    constructor(el) {
        super(el);
        this.slotName = 'footer';
        this.submitted = new EventEmitter();
    }
    _handleMessageInputAction(event) {
        const { detail: { message }, } = event;
        this.submitted.emit(message);
    }
}
FadvMessageInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvMessageInputComponent, deps: [{ token: ElementRef }], target: i0.ɵɵFactoryTarget.Component });
FadvMessageInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvMessageInputComponent, selector: "fadv-message-input", inputs: { placeholder: "placeholder", minlength: "minlength", maxlength: "maxlength", label: "label" }, outputs: { focused: "focused", blurred: "blurred", submitted: "submitted" }, host: { listeners: { "fadv-message-submitted": "_handleMessageInputAction($event)" }, properties: { "slot": "this.slotName" } }, usesInheritance: true, ngImport: i0, template: '', isInline: true });
__decorate([
    Forward()
], FadvMessageInputComponent.prototype, "placeholder", void 0);
__decorate([
    Forward()
], FadvMessageInputComponent.prototype, "minlength", void 0);
__decorate([
    Forward()
], FadvMessageInputComponent.prototype, "maxlength", void 0);
__decorate([
    Forward()
], FadvMessageInputComponent.prototype, "label", void 0);
__decorate([
    Track()
], FadvMessageInputComponent.prototype, "submitted", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvMessageInputComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-message-input',
                    template: '',
                    outputs: [focusEventOutput, blurEventOutput],
                }]
        }], ctorParameters: function () {
        return [{ type: i0.ElementRef, decorators: [{
                        type: Inject,
                        args: [ElementRef]
                    }] }];
    }, propDecorators: { slotName: [{
                type: HostBinding,
                args: ['slot']
            }], placeholder: [{
                type: Input
            }], minlength: [{
                type: Input
            }], maxlength: [{
                type: Input
            }], label: [{
                type: Input
            }], submitted: [{
                type: Output
            }], _handleMessageInputAction: [{
                type: HostListener,
                args: ['fadv-message-submitted', ['$event']]
            }] } });
class FadvMessageBoxHeaderComponent extends FadvBaseComponent {
    constructor() {
        super(...arguments);
        this.slotName = 'header';
    }
}
FadvMessageBoxHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvMessageBoxHeaderComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
FadvMessageBoxHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvMessageBoxHeaderComponent, selector: "fadv-message-box-header", host: { properties: { "slot": "this.slotName" } }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvMessageBoxHeaderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-message-box-header',
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { slotName: [{
                type: HostBinding,
                args: ['slot']
            }] } });
class FadvMessageBoxComponent extends FadvBaseComponent {
    constructor() {
        super(...arguments);
        this.height = 'small';
        this.scrollStart = 'top';
    }
}
FadvMessageBoxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvMessageBoxComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
FadvMessageBoxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvMessageBoxComponent, selector: "fadv-message-box", inputs: { height: "height", scrollStart: "scrollStart" }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
__decorate([
    Forward()
], FadvMessageBoxComponent.prototype, "height", void 0);
__decorate([
    Forward()
], FadvMessageBoxComponent.prototype, "scrollStart", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvMessageBoxComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-message-box',
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { height: [{
                type: Input
            }], scrollStart: [{
                type: Input
            }] } });

class FadvMessageBoxModule {
}
FadvMessageBoxModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvMessageBoxModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FadvMessageBoxModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: FadvMessageBoxModule, declarations: [FadvMessageBoxComponent, FadvMessageComponent, FadvMessageInputComponent, FadvMessageBoxHeaderComponent], imports: [FadvCommonModule, FadvIconModule], exports: [FadvMessageBoxComponent, FadvMessageComponent, FadvMessageInputComponent, FadvMessageBoxHeaderComponent] });
FadvMessageBoxModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvMessageBoxModule, imports: [FadvCommonModule, FadvIconModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvMessageBoxModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FadvMessageBoxComponent, FadvMessageComponent, FadvMessageInputComponent, FadvMessageBoxHeaderComponent],
                    imports: [FadvCommonModule, FadvIconModule],
                    exports: [FadvMessageBoxComponent, FadvMessageComponent, FadvMessageInputComponent, FadvMessageBoxHeaderComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FadvMessageBoxComponent, FadvMessageBoxHeaderComponent, FadvMessageBoxModule, FadvMessageComponent, FadvMessageInputComponent };
